const translations: Record<string, string> = {
  "ak_dsp3_xml_generated_mwh_split_across_assets": "XML сформовано: {{mwh}} МВт·год, розкладка по {{n}} активах.",
  "ak_dsp3_version_for_deleted": "Версію {{rev}} за {{d}} видалено.",
  "ak_dsp3_delivery_day_kyiv_time": "доба поставки {{d}} · час київський",
  "ak_dsp3_version": "Версія {{n}}",
  "ak_dsp3_progress_version": "Перебіг · Версія {{n}}",
  "ak_dsp3_send_to_mms_submits_the_generated_xml": "«Відправити на MMS» подає сформований XML-графік до Укренерго через API (mTLS SOAP через jmms). Статус подачі — у стрічці подій вище (queued → submitted / error). Валідація Укренерго асинхронна; помилка авторизації означає, що техкористувача ще не провіжено на їхньому боці.",
  "ak_dsp3_manual_entry_version": "Ручне внесення — Версія {{n}}",
  "ak_dsp3_versions": "версій: {{n}}",
  "ak_dsp3_version_2": "версія {{n}}",
  "ak_dsp3_your_solar_plant_kwh": "ваша СЕС {{n}} кВт·год",
  "ak_dsp3_the_schedule_is_submitted_for_group_de": "Графік подається на групу {{x}} — видалення прибере версію і для: {{a}}",
  "ak_dsp3_select_an_entry_its_hourly_values_will": "Оберіть запис — його погодинні значення підтягнуться у «Погодинні дані» разом із фактом за ту добу, якщо вона вже минула.",
  "ak_dsp3_version_history_for": "Історія версій за {{d}}",
  "ak_dsp3_error": "Помилка",
  "ak_dsp3_the_schedule_has_been_queued_for_submi": "Графік поставлено в чергу на відправку до MMS. Статус оновиться протягом ~2 хв.",
  "ak_dsp3_journal_entry_updated": "Запис у журналі оновлено.",
  "ak_dsp3_generated": "Сформовано",
  "ak_dsp3_submitted_to_mms": "Передано до MMS",
  "ak_dsp3_received_by_mms": "Прийнято MMS",
  "ak_dsp3_processed_by_mms": "Оброблено MMS",
  "ak_dsp3_status": "Статус",
  "ak_dsp3_mms_interaction_log": "Журнал взаємодії з MMS",
  "ak_dsp3_loading": "Завантаження…",
  "ak_dsp3_no_journal_data_for_this_station": "Немає даних журналу для цієї станції.",
  "ak_dsp3_schedule_versions": "Версії графіка",
  "ak_dsp3_mwh": "МВт·год",
  "ak_dsp3_ukrenergo_response": "Відповідь Укренерго",
  "ak_dsp3_show_xml_response": "показати XML-відповідь",
  "ak_dsp3_generate_xml_build_the_schedule_from_t": "Сформувати XML: побудувати графік із прогнозу з урахуванням ручних коригувань",
  "ak_dsp3_available_for_the_active_version_only": "Доступно лише для активної версії",
  "ak_dsp3_download_xml": "Завантажити XML",
  "ak_dsp3_send_to_mms_queue_the_schedule_and_sub": "Відправити до MMS: поставити графік у чергу й подати через API (Укренерго)",
  "ak_dsp3_generate_the_xml_first": "Спершу сформуйте XML",
  "ak_dsp3_hide_xml_archive": "Сховати архів XML",
  "ak_dsp3_xml_archive": "Архів XML",
  "ak_dsp3_collapse_manual_entry": "Згорнути внесення вручну",
  "ak_dsp3_enter_manually_record_mms_times_and_st": "Внести вручну: записати часи та статус MMS",
  "ak_dsp3_time_sent_to_mms": "Час відправлення на MMS",
  "ak_dsp3_time_received_by_mms": "Час отримання MMS",
  "ak_dsp3_status_message_time": "Час повідомлення про статус",
  "ak_dsp3_mms_status": "Статус MMS",
  "ak_dsp3_not_set": "— не задано —",
  "ak_dsp3_saving": "Збереження…",
  "ak_dsp3_save_entry": "Зберегти запис",
  "ak_dsp3_an_empty_field_means_no_change_time_is": "Порожнє поле — не змінювати. Час вводиться за київським.",
  "ak_dsp3_saved_schedules": "Збережені графіки",
  "ak_dsp3_delete_the_saved_schedule_version": "Видалити збережену версію графіка",
  "ak_dsp3_delete_for_the_whole_group": "Видалити для всієї групи?",
  "ak_dsp3_confirm": "Підтвердити?",
  "ak_dsp3_the_schedule_was_already_submitted_the": "Графік уже відправляли — запис лишається в журналі",
  "ak_dsp3_version_3": "Версія",
  "ak_dsp3_state": "Стан",
  "ak_dsp3_submitted": "Передано",
  "ak_dsp3_received": "Прийнято",
  "ak_dsp3_processed": "Оброблено",
  "ak_dsp3_by": "Хто",
};

export default translations;
